// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".body-font[data-v-7dedcfb0],.title-font[data-v-7dedcfb0]{font-family:-apple-system,BlinkMacSystemFont,sans-serif!important}.f-h[data-v-7dedcfb0]{height:100vh}.relative_container[data-v-7dedcfb0]{position:relative}.social_container[data-v-7dedcfb0]{position:fixed;width:50px;height:50px;bottom:10px;right:20px;z-index:100}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
